/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 16,
    height: 18,
    viewBox: '0 0 16 18',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-calendar-a" transform="translate(0 2)"/><use xlink:href="#svgicon-calendar-b" transform="matrix(0 -1 1 0 2 3)"/><use xlink:href="#svgicon-calendar-b" transform="matrix(0 -1 1 0 12 3)"/><defs><path pid="0" id="svgicon-calendar-a" fill-rule="evenodd" d="M16 0H0v16h16V0zm-3 3H3v2h10V3zM3 7h2v2H3V7zm6 0H7v2h2V7zm2 0h2v2h-2V7zm-6 4H3v2h2v-2zm2 0h2v2H7v-2zm6 0h-2v2h2v-2z"/><path pid="1" id="svgicon-calendar-b" fill-rule="evenodd" d="M3 2H0V0h3v2z"/></defs>`
  }
})
